import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|Summary|Affiliations';

export type CandidateAffiliationLocs = 'SPCandidateAffiliationsCatalogExternalId';

const sharedLocProperties = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
};

export const spCandidatAffiliationLocs: LocDefs<CandidateAffiliationLocs> = {
	SPCandidateAffiliationsCatalogExternalId: {
		...sharedLocProperties,
		defaultValue: 'Catalog External Id',
		description: 'Label for the affiliation catalog external ID.',
		displayPath: `${dpRoot}|Catalog External Id`,
		displayType: 'Label',
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<CandidateAffiliationLocs>(spCandidatAffiliationLocs);
